import {  FaWhatsapp as whatsappIcon ,FaFacebook as IconFacebook,FaTwitter as IconTwitter, FaInstagram as IconInstagram, FaLinkedin as IconLinkedin,FaPhone as IconTelefone, FaHeadset as IconSuporte, FaWifi as IconWifi, FaStar as IconAvaliacao, FaTag as IconPromocao } from 'react-icons/fa';
import {MdEmail as IconEmail } from 'react-icons/md';
import { AiOutlineCloud as IconNuvem} from 'react-icons/ai';


const comboIconMap = {
    telefone: IconTelefone,
    suporte: IconSuporte,
    nuvem: IconNuvem,
    avaliacao: IconAvaliacao,
    promocao: IconPromocao,
    wifi: IconWifi,
};

const mediaIconMap = {
    whatsapp:whatsappIcon,
    telefone: IconTelefone,
    email: IconEmail,
    facebook: IconFacebook,
    twitter: IconTwitter,
    instagram: IconInstagram,
    linkedin: IconLinkedin,
};

const contatoIconMap = {
    whatsapp:whatsappIcon,
    telefone: IconTelefone,
    email: IconEmail,
    facebook: IconFacebook,
    twitter: IconTwitter,
    instagram: IconInstagram,
    linkedin: IconLinkedin,
};




export const getIcon = (iconName,section) => {
    const iconMaps = {
        comboIcon:comboIconMap,
        mediaIcon:mediaIconMap,
        contatoIcon:contatoIconMap


    };
    return iconMaps[section]?.[iconName] || IconTelefone; //Retorno padrão do icone

};

//exportar para cada seção

export const comboIconOptions = Object.keys(comboIconMap).map(key => ({
    value: key,
    label: key.charAt(0).toUpperCase() + key.slice(1)
}));
export const mediaIconOptions = Object.keys(mediaIconMap).map(key => ({
    value: key,
    label: key.charAt(0).toUpperCase() + key.slice(1)
}));
export const contatoIconOptions = Object.keys(contatoIconMap).map(key => ({
    value: key,
    label: key.charAt(0).toUpperCase() + key.slice(1)
}));